import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  pendingOfferContainer: {
    padding: '15px',
    // backgroundColor: 'red',
    maxWidth: '100%',
    width: '100%',
    margin: '0 auto',
    filter: 'drop-shadow(2px 2px 2px rgba(157, 157, 156, 0.251))',
    [theme.breakpoints.up('md')]: {
      padding: '20px',
      maxWidth: '600px',
    }
  },
  notificationBox: {
    backgroundColor: 'rgba(198, 198, 197, 0.21)',
    border: 'solid 1px rgba(0, 0, 0, 0.15)',
    borderLeft: `4px solid ${theme.colors.primary.Darkblue}`,
    padding: '15px',
    marginBottom: '20px',
    borderRadius: '6px',
    wordWrap: 'break-word'
  },
  notificationTitle: {
    fontFamily: theme.fonts.family.primary,
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '16px',
    lineHeight: '25px',
    color: theme.colors.primary.Darkblue,
    marginBottom: '10px',
    [theme.breakpoints.up('md')]: {
      fontSize: '21.335px',
    }
  },
  notificationText: {
    fontFamily: theme.fonts.family.primary,
    fontStyle: 'normal',
    fontWeight: '300',
    fontSize: '15px',
    lineHeight: '20px',
    color: '#3C3C3B',
    marginBottom: '12px',
    [theme.breakpoints.up('xs')]: {
      fontSize: '14px',
    }
  },
  amountHighlight: {
    fontFamily: theme.fonts.family.primary,
    fontWeight: '600',
    color: theme.colors.secondary.Green,
  },
  actionButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginTop: '20px',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    }
  },
  acceptButton: {
    "&.MuiButtonBase-root": {
      height: "52.22px",
      width: "100%",
      backgroundColor: theme.colors.primary.Darkblue,
      "&:hover": {
        backgroundColor: theme.colors.secondary.Green,
      },
      "& .MuiTypography-root": {
        fontSize: 13,
        fontFamily: theme.fonts.family.primary,
        fontWeight: "600",
        letterSpacing: "0.2em",
      },
      [theme.breakpoints.up('sm')]: {
        width: 'auto',
        marginRight: '10px',
      }
    }
  },
  rejectButton: {
    "&.MuiButtonBase-root": {
      height: "52.22px",
      width: "100%",
      backgroundColor: "#F4EBFE",
      color: theme.colors.primary.Darkblue,
      "&:hover": {
        backgroundColor: theme.colors.primary.Darkblue,
        color: "#ffffff"
      },
      "& .MuiTypography-root": {
        fontSize: 13,
        fontFamily: theme.fonts.family.primary,
        fontWeight: "600",
        letterSpacing: "0.2em",
      },
      [theme.breakpoints.up('sm')]: {
        width: 'auto',
      }
    }
  }
}));
